(ns app.front.view.admin.commands.remove-orphaned-businesses
  (:require [app.front.ui :as ui]
            [app.front.view.admin.common :as acommon]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::remove-orphaned-business-imports
  (fn [_ [_ group-id]]
    {:comm/command {:command    :admin/remove-orphaned-business-imports
                    :data       (util/mmap group-id)
                    :on-success [::remove-orphaned-business-imports.success]}}))

(rf/reg-event-fx ::remove-orphaned-business-imports.success
  (fn [_ [_ _ {:keys [result]}]]
    {:dispatch [:notifications/add :toast :success :success result]}))

(defn view [_]
  (r/with-let [*group-id (r/atom nil)]
    (let [tr (<sub [:tr])]
      [:div.cloudpermit-page.admin-page
       [:section
        [ui/help
         (str "If a data-import has added business records / entities to the system, but has then been removed, and "
              "nothing else is referencing those business records either, this command can be used to remove those "
              "records completely.")]
        [:div.flex.items-end
         [:div.w-1-2.xxl:w-2-5
          [acommon/group-selector {:tr        tr
                                   :on-change #(reset! *group-id (:group-id %))}]]
         [:div.ml-4
          [ui/modal-confirmation-button
           (util/mmap {:on-yes-click        (fn [_]
                                              (>evt [::remove-orphaned-business-imports @*group-id])
                                              (reset! *group-id nil))
                       :trigger-button-opts {:size     :field
                                             :disabled (nil? @*group-id)}
                       :trigger-button-text "Remove business records"}
                      tr)
           [:p "Remove the unused business records from data import sessions of group: "
            [:span.bold @*group-id]]]]]]])))

(def route
  {:name :view/admin.commands.remove-orphaned-business-imports
   :view view})
